import React, { useState, useEffect, useCallback } from 'react';
import SelectMenu from '../common/forms/selectmenu';
import LabelInput from '../common/forms/Labelinput';
import DateLabelInput from '../common/forms/DateLabelInput';
import Button from '../common/ui/button';
import CancelButton from '../common/ui/cancelbutton';
import { MdEditSquare } from 'react-icons/md';
import { RiDeleteBin5Line } from 'react-icons/ri';
import NoFound from '../common/ui/NoFound';
import toast from 'react-hot-toast';
import RadioLabelInput from "../common/forms/radiolabelinput";
import { DeletePreviewModal, FinalDeleteConfirmModal } from "../common/ui/deletemodal";
import { API_CONFIG, getHeaders, refreshAccessToken } from "../../config/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import WarningModal from '../common/ui/warningmodel';


export default function EditExbondform({
  formData,
  updateFormData,
  records,
  setRecords,
  allRecords,
  resultantOptions,
  loadingResultants,
  sectionOptions,
  loadingSections,
  exbondExportOptions,
  customerOptions,
  loadingCustomers,
  biNumberOptions,
  loadingBINumber,
  onBINumberChange,
  materialOptions,
  onFetchWeightDuty,
  availableWeights, // ✅ Receive available weights
  masterrecords,
  initialEditIndex,
  selectedchildId
}) {
  const [editIndex, setEditIndex] = useState(initialEditIndex || null);
  const [pendingDeleteData, setPendingDeleteData] = useState(null);
  const [deleteMode, setDeleteMode] = useState(null); // "child"
  const [showDeletePreview, setShowDeletePreview] = useState(false);
  const [showFinalDeleteConfirm, setShowFinalDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [materialsList, setMaterials] = useState([]);
  const [loadingMaterials, setLoadingMaterials] = useState(false);
  const { logout } = useAuth();
  const [inbondExbondWeight, setInbondExbondWeight] = useState(null);
  const [warningVisible, setWarningVisible] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");




  useEffect(() => {
    if (initialEditIndex !== null && records.length > 0) {
      handleEditEntry(initialEditIndex);
    }
  }, [initialEditIndex, records]);
  const dutypaidOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];


  const getLabelFromOptions = (options, value) => {
    const found = options?.find(opt => opt.value === value);
    return found ? found.label : value || "—";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };
  const fetchMaterialInbondDate = useCallback(async (inbond_master_id) => {
    if (!inbond_master_id) return;

    try {
      setLoadingMaterials(true);

      let response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_MATERIAL_INBOND_DATE(inbond_master_id)}`,
        { headers: getHeaders(true) }
      );

      if (response.status === 401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
          response = await fetch(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.GET_MATERIAL_INBOND_DATE(inbond_master_id)}`,
            { headers: getHeaders(true) }
          );
        } else {
          logout();
          return;
        }
      }

      const result = await response.json();

      if (result.status === 200) {

        const list = result.data.map(item => ({
          label: item.material_name,
          value: item.material_master_id,
          weight: item.material_weight,
          beDate: item.inbond_be_date,
          inbond_child_id: item.inbond_child_id,
          material_short_code: item.material_short_code,
        }));

        setMaterials(list);
        return list;
      }

    } finally {
      setLoadingMaterials(false);
    }
  }, [logout]);

  const handleMaterialSelect = async (selectedMaterialObj) => {
    if (!selectedMaterialObj) return;

    updateFormData("material", selectedMaterialObj.value);
    updateFormData("materialNameOnly", selectedMaterialObj.label);
    updateFormData("materialShortCode", selectedMaterialObj.material_short_code);
    updateFormData("weight", selectedMaterialObj.weight);
    updateFormData("beDate", selectedMaterialObj.beDate);
    updateFormData("inbond_child_id", selectedMaterialObj.inbond_child_id);

    // Fetch weight/duty immediately
    if (selectedMaterialObj.inbond_child_id) {
      const availableWeight = await onFetchWeightDuty(selectedMaterialObj.inbond_child_id);
      setInbondExbondWeight(Number(availableWeight) || 0);
    } else {
      setInbondExbondWeight(0);
    }
  };

  // BI number select
  const handleBINumberSelect = async (biNumberValue) => {
    updateFormData("biNumber", biNumberValue);

    const selectedBI = biNumberOptions.find(opt => opt.value === biNumberValue);
    if (!selectedBI) return;

    updateFormData("inbond_master_id", selectedBI.value);

    // Fetch materials
    const materialList = await fetchMaterialInbondDate(selectedBI.value);
    setMaterials(materialList || []);

    if (materialList?.length) {
      const selectedMaterialObj = materialList[0];
      await handleMaterialSelect(selectedMaterialObj); // use unified handler
    } else {
      // Reset
      updateFormData("material", "");
      updateFormData("materialNameOnly", "");
      updateFormData("materialShortCode", "");
      updateFormData("weight", "");
      updateFormData("beDate", "");
      updateFormData("inbond_child_id", "");
      setInbondExbondWeight(0);
    }
  };



  /** Handle Editing an Entry */
  const handleEditEntry = async (id) => {

    // const entry = records.find(r => String(r.id) === String(id));
    const entry = (selectedchildId !== 0 && selectedchildId !== null)
      ? records.find(r => String(r.id) === String(selectedchildId))
      : records.find(r => String(r.id) === String(id));


    Object.keys(entry).forEach((key) => updateFormData(key, entry[key]));
    const materialList = await fetchMaterialInbondDate(entry.inbond_master_id);
    const selectedMaterialObj = materialList.find(
      (item) => String(item.value) === String(entry.material)
    );

    // Ensure IDs are preserved
    updateFormData("id", entry.id);
    updateFormData("inbond_master_id", entry.inbond_master_id);
    updateFormData("biNumberId", entry.biNumberId);
    updateFormData("biNumber", entry.biNumber);
    updateFormData("beNumber", entry.beNumber);
    updateFormData("beDate", entry.beDate);
    updateFormData("section", entry.section);
    updateFormData("customer", entry.customer);
    updateFormData("exbondExport", entry.exbondExport);
    updateFormData("dutyExbond", entry.dutyExbond);
    updateFormData("dollar", entry.dollar);
    updateFormData("rate", entry.rate);
    updateFormData("apifetchweight", entry.apifetchweight);
    updateFormData("invoiceValue", entry.invoiceValue);
    updateFormData("dutypaid", entry.dutypaid);

    // ✅ FIX: Match resultant by FULL NAME from API, then get short code
    // API returns full material name in entry.resultantName
    // We need to find the matching material by name to get its ID and short code
    const resultantObj = resultantOptions.find(r =>
      r.fullName?.toLowerCase() === entry.resultantName?.toLowerCase() ||
      String(r.value) === String(entry.resultant)
    );


    // Set resultant with ID (for dropdown value) and short code (for display)
    updateFormData("resultant", resultantObj?.value || entry.resultant);
    updateFormData("resultantName", resultantObj?.fullName || entry.resultantName);
    updateFormData("resultantShortCode", resultantObj?.material_short_code || "");

    // Handle material
    if (selectedMaterialObj) {
      updateFormData("material", selectedMaterialObj.value);
      updateFormData("materialNameOnly", selectedMaterialObj.label || selectedMaterialObj.material_short_code);
      updateFormData("materialShortCode", selectedMaterialObj.material_short_code || selectedMaterialObj.label);
      updateFormData("inbond_child_id", selectedMaterialObj.inbond_child_id || "");
    } else {
      updateFormData("material", entry.material);
      updateFormData("materialNameOnly", entry.materialNameOnly || entry.materialShortCode);
      updateFormData("materialShortCode", entry.materialShortCode || entry.materialNameOnly);
    }

    if (selectedMaterialObj?.inbond_child_id) {
      const availableWeight = await onFetchWeightDuty(selectedMaterialObj.inbond_child_id);
      const currentAvailableWeight = Number(availableWeight) || 0;
      const OldWeight = Number(entry.apifetchweight) || 0;
      const finalWeight = currentAvailableWeight + OldWeight;
      setInbondExbondWeight(finalWeight);
    }

    setEditIndex(id);
  };




  /** Reset Form Fields */
  const resetForm = () => {
    const fields = [
      'biNumber',
      'beNumber',
      'beDate',
      'section',
      'exbondExport',
      'resultant',
      'material',
      'dutyExbond',
      'dollar',
      'rate',
      'apifetchweight',
      'invoiceValue',
      'customer',
      'dutypaid'
    ];
    fields.forEach((field) => updateFormData(field, ''));
    setEditIndex(null);
  };
  const totalDuty = allRecords.reduce((sum, r) => sum + Number(r.dutyExbond || 0), 0);
  const totalWeight = allRecords.reduce((sum, r) => sum + Number(r.apifetchweight || 0), 0);
  /** Add or Update Record */

  // On page load or when selectedchildId changes
  // On page load or when selectedchildId changes
  useEffect(() => {
    if (selectedchildId !== "" && selectedchildId !== 0 && records.length > 0 && editIndex === null) {
      const entryIndex = records.findIndex(record => String(record.id) === String(selectedchildId));
      if (entryIndex !== -1) {
        const entry = records[entryIndex];

        // Populate form data
        updateFormData("material", String(entry.material_master_id || ""));
        updateFormData("weight", String(entry.apifetchweight || ""));
        updateFormData("invoiceValue", String(entry.invoice_amount_usd || ""));
        updateFormData("dollar", String(entry.dollar_inr || ""));
        updateFormData("price", String(entry.price || ""));
        updateFormData("duty", String(entry.duty_inbond_amount_inr || ""));
        updateFormData("assessment", String(entry.assessment_amount_inr || ""));
        updateFormData("totalAmount", String(entry.material_amount_usd || ""));
        updateFormData("id", String(entry.id || ""));

        // Set edit index so the form is in "edit mode"
        setEditIndex(entryIndex);
      }
    }
  }, [selectedchildId]);

  const handleAddEntry = async () => {
    const {
      biNumber,
      inbond_master_id,
      inbond_child_id,
      beNumber,
      beDate,
      section,
      exbondExport,
      resultant,
      resultantName,
      material,
      materialNameOnly,
      dutyExbond,
      dollar,
      rate,
      apifetchweight,
      invoiceValue,
      customer,
      dutypaid,
      id
    } = formData;

    // -----------------------------
    // REQUIRED FIELD VALIDATION
    // -----------------------------
    if (
      !biNumber ||
      !beNumber ||
      !beDate ||
      !section ||
      !exbondExport ||
      !resultant ||
      !material ||
      !dutyExbond ||
      !apifetchweight ||
      !invoiceValue ||
      customer === "" ||
      dutypaid === null ||
      dutypaid === undefined
    ) {
      toast.error("Please fill all required fields!");
      setWarningMessage("Please fill all required fields!");
      setWarningVisible(true);
      return;
    }

    // -----------------------------
    // WEIGHT VALIDATION
    // -----------------------------
    const availableWeight = await onFetchWeightDuty(inbond_child_id);
    const currentAvailableWeight = Number(availableWeight) || 0;
    const oldWeight = Number(apifetchweight) || 0;
    const finalWeight = currentAvailableWeight + oldWeight;

    setInbondExbondWeight(finalWeight);

    // -----------------------------
    // BUILD NEW RECORD OBJECT
    // -----------------------------
    const selectedMaterialShortCode =
      formData.materialShortCode || materialNameOnly || "";

    const newRecord = {
      id: id || null,
      inbond_master_id: Number(inbond_master_id),
      inbond_child_id: Number(inbond_child_id),
      biNumber,
      beNumber,
      beDate,
      section,
      customer,
      exbondExport,
      resultant,
      resultantName,
      resultantShortCode: formData.resultantShortCode,
      material,
      materialNameOnly,
      material_short_code: selectedMaterialShortCode,
      dutyExbond,
      dollar,
      rate,
      apifetchweight,
      invoiceValue,
      dutypaid,
    };

    // -----------------------------
    // UPDATE OR ADD NEW ENTRY
    // -----------------------------
    if (id) {
      // Check if record with same ID exists
      const existingIndex = records.findIndex(r => String(r.id) === String(id));
      if (existingIndex !== -1) {
        // UPDATE
        const updated = [...records];
        updated[existingIndex] = newRecord;
        setRecords(updated);
        toast.success("Record updated!");
      } else {
        // ID provided but not found → add new
        setRecords([...records, newRecord]);
        toast.success("Record added!");
      }
    } else {
      // New record without ID → add new
      const tempId = crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
      setRecords([...records, { ...newRecord, tempId }]);
      toast.success("Record added!");
    }

    // Reset form
    resetForm();
  };



  const handleDeleteChild = (child) => {
    setPendingDeleteData({ child });
    setDeleteMode("child");
    setShowDeletePreview(true);
    setShowFinalDeleteConfirm(false);
  };
  const handleCancelPreview = () => {
    setShowDeletePreview(false);
    setPendingDeleteData(null);
    setDeleteMode(null);
  };
  const handleProceedToFinalConfirm = () => {
    setShowDeletePreview(false);
    setShowFinalDeleteConfirm(true);
  };
const handleConfirmDelete = async () => {
  if (!pendingDeleteData) return;

  const child = pendingDeleteData.child;
  const childId = child.id; // use the id for backend deletion

  setLoading(true);

  try {
    if (!childId) {
      // New frontend-only record
      setRecords(prev => prev.filter(r => r.tempId !== child.tempId));
      toast.success("New entry removed successfully");
    } else {
      // Delete from backend
      let response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.SOFT_DELETE_PARTIAL(childId)}`,
        { method: "PUT", headers: getHeaders(true) }
      );

      if (response.status === 401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
          response = await fetch(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.EXBOND.SOFT_DELETE_PARTIAL(childId)}`,
            { method: "PUT", headers: getHeaders(true) }
          );
        } else {
          logout();
          return;
        }
      }

      const result = await response.json().catch(() => ({}));
      if (response.ok && result.status === 200) {
        toast.success(result.message || "Child deleted successfully");
        setRecords(prev => prev.filter(r => r.id !== childId));
        navigate('/ex-bond');
      } else {
        setWarningMessage(result.message || "Failed to delete child");
        setWarningVisible(true);
      }
    }
  } catch (err) {
    console.error(err);
    setWarningMessage("Unexpected error while deleting entry");
    setWarningVisible(true);
  } finally {
    setLoading(false);
    setShowFinalDeleteConfirm(false);
    setPendingDeleteData(null);
    setDeleteMode(null);
  }
};




  // In EditExbondform render, before passing options to SelectMenu
  const materialOptionsWithCurrent = materialOptions.map(e => ({
    value: String(e.value),
    label: e.material_short_code.toUpperCase(),
    nameOnly: e.nameOnly,
    shortCode: e.material_short_code,
    inbond_child_id: String(e.inbond_child_id)
  }));






  const formatIndianNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "0";
    return Number(num).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };


  return (
    <>
      <div className="space-y-4 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4 items-start">
          {/* LEFT SIDE FORM */}
          <div className="lg:col-span-4 bg-white shadow-soft border border-gray-100 rounded p-5 space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <SelectMenu
                label="BI No."
                name="biNumber"
                value={formData.biNumber}
                onChange={handleBINumberSelect}  // ✅ Use new handler
                options={biNumberOptions}
                loading={loadingBINumber}
                searchable
                required
                usePortal
              />



              <LabelInput
                label="BE No."
                type="text"
                name="beNumber"
                value={formData.beNumber}
                onChange={(e) => updateFormData('beNumber', e.target.value)}
                required
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div className="relative overflow-visible z-50">
                {/* <SelectMenu
                  label="Material"
                  name="material"
                  value={(formData.materialShortCode || "").toUpperCase()}

                  onChange={(v) => {
                    const selected = materialsList.find(opt => String(opt.value) === String(v));

                    updateFormData("material", v);
                    updateFormData("materialNameOnly", selected?.label || "");
                    updateFormData("materialShortCode", selected?.material_short_code || "");
                    updateFormData("inbond_child_id", selected?.inbond_child_id || "");

                    if (selected?.inbond_child_id) {
                      onFetchWeightDuty(selected.inbond_child_id);
                    }
                  }}
                  options={materialsList.map(m => ({
                    value: String(m.value),
                    label: m.material_short_code.toUpperCase(),
                    inbond_child_id: String(m.inbond_child_id)
                  }))}
                  loading={loadingMaterials}
                  required
                /> */}
                <SelectMenu
                  label="Material"
                  name="material"
                  value={(formData.materialShortCode || "").toUpperCase()}
                  onChange={async (v) => {
                    const selected = materialsList.find(opt => String(opt.value) === String(v));
                    await handleMaterialSelect(selected);
                  }}
                  options={materialsList.map(m => ({
                    value: String(m.value),
                    label: m.material_short_code.toUpperCase(),
                    inbond_child_id: String(m.inbond_child_id),
                  }))}
                  loading={loadingMaterials}
                  required
                />


              </div>
              <SelectMenu
                label="Resultant"
                name="resultant"
                value={formData.resultant}  // ✅ This should be the material_id
                onChange={(v) => {
                  const selected = resultantOptions.find(opt => opt.value === v);

                  updateFormData("resultant", v);                                    // Store ID
                  updateFormData("resultantName", selected?.fullName || "");         // Store full name
                  updateFormData("resultantShortCode", selected?.material_short_code || ""); // Store short code
                }}
                options={resultantOptions}  // ✅ Shows short codes as labels
                loading={loadingResultants}
                searchable
                required
                usePortal
              />




            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <DateLabelInput
                label="BE Date"
                name="beDate"
                type="date"
                value={formData.beDate}
                onChange={(e) => {
                  const selectedDate = e.target.value;
                  const inbondDate = formData.beDate;

                  if (inbondDate && new Date(selectedDate) < new Date(inbondDate)) {
                    setWarningMessage("BE Date cannot be earlier than Inbond BE Date!");
                    setWarningVisible(true);
                    return;
                  }

                  updateFormData("beDate", selectedDate);
                }}
                required
                disabled={!formData.material}
              />

              <SelectMenu
                label="Section"
                name="section"
                value={formData.section}
                onChange={(v) => updateFormData('section', v)}
                options={sectionOptions}
                loading={loadingSections}
                searchable
                required
                usePortal
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <SelectMenu
                label="Exbond/Export"
                name="exbondExport"
                value={formData.exbondExport}
                onChange={(v) => updateFormData('exbondExport', v)}
                options={exbondExportOptions}
                required
                usePortal
              />
              <LabelInput
                label="Duty Ex-bond (₹)"
                type="number"
                name="dutyExbond"
                value={formData.dutyExbond}
                onChange={(e) => updateFormData('dutyExbond', e.target.value)}
                required
              />

            </div>



            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <LabelInput
                label="Dollar (₹) (ER)"
                type="number"
                name="dollar"
                value={formData.dollar}
                onChange={(e) => updateFormData('dollar', e.target.value)}
              />
              <LabelInput
                label="Rate"
                type="number"
                name="rate"
                value={formData.rate}
                onChange={(e) => updateFormData('rate', e.target.value)}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div>
                <LabelInput
                  label="Weight (kg)"
                  type="number"
                  name="apifetchweight"
                  value={formData.apifetchweight}
                  onChange={(e) => {
                    const enteredWeight = e.target.value;
                    updateFormData('apifetchweight', enteredWeight);

                    // ✅ Validate weight in real-time using inbondExbondWeight
                    if (formData.material && enteredWeight) {
                      const weightNum = Number(enteredWeight);

                      if (
                        inbondExbondWeight !== undefined &&
                        weightNum > inbondExbondWeight
                      ) {
                        setWarningMessage(
                          `Entered weight (${weightNum} kg) exceeds available weight (${inbondExbondWeight} kg)!`
                        );
                        setWarningVisible(true);
                      }
                    }

                  }}
                  required
                />

              </div>
              <LabelInput
                label="Invoice Value ($)"
                type="number"
                name="invoiceValue"
                value={formData.invoiceValue}
                onChange={(e) => updateFormData('invoiceValue', e.target.value)}
                required
              />
            </div>
            <RadioLabelInput
              label="Duty Paid"
              name="dutypaid"
              required={true}
              value={formData.dutypaid}               // boolean
              onChange={(val) => updateFormData("dutypaid", val)} // val = true/false
              options={dutypaidOptions}
            />
            <SelectMenu
              label="Customer"
              name="customer"
              value={formData.customer}
              onChange={(v) => updateFormData('customer', v)}
              options={customerOptions}
              loading={loadingCustomers}
              searchable
              required
              usePortal
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-4">
              <Button onClick={handleAddEntry} id={editIndex}>

                {editIndex !== null ? 'Update Entry' : 'Add Entry'}
              </Button>
              <CancelButton onClick={resetForm}>Reset</CancelButton>
            </div>
          </div>

          {/* RIGHT SIDE TABLE */}
          <div className="lg:col-span-8 space-y-2">
            {records.length > 0 ? (
              <div className="overflow-x-auto p-2">
                <table className="min-w-full text-[13px] border-collapse">
                  <thead>
                    <tr>
                      <th className="text-left text-gray-700 font-semibold px-3 py-2 w-40">
                        Field Name
                      </th>
                      {records.map((record, idx) => (
                        <th
                          key={idx}
                          className="text-left text-gray-700 font-semibold px-3 py-1 border-l border-gray-200"
                        >
                          Record {idx + 1}
                          <div className="flex justify-start gap-2 mt-1">
                            <button

                              onClick={() => handleEditEntry(record.id)}
                              className="text-green-600 hover:text-green-700"
                              title="Edit"
                            >
                              <MdEditSquare size={15} />
                            </button>
                            <button
                              onClick={() => handleDeleteChild(record)}
                              className="text-red-500 hover:text-red-700"
                              title="Delete"
                            >
                              <RiDeleteBin5Line size={15} />
                            </button>

                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BI No.</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">
                          {getLabelFromOptions(biNumberOptions, r.biNumber)?.toUpperCase() || ""}
                        </td>
                      ))}
                    </tr>

                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BE No.</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.beNumber || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BE Date</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">
                          {formatDate(r.beDate)}
                        </td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Section</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{getLabelFromOptions(sectionOptions, r.section)}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Exbond/Export</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.exbondExport || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Resultant</td>
                      {records.map((r, i) => {
                        // ✅ Try to find short code from resultantOptions if not stored
                        const resultantObj = resultantOptions.find(opt =>
                          opt.fullName?.toLowerCase() === r.resultantName?.toLowerCase()
                        );
                        const displayText = r.resultantShortCode || resultantObj?.material_short_code || r.resultantName;

                        return (
                          <td key={i} className="px-3 py-1.5 border-l text-left">
                            {displayText?.toUpperCase() || "—"}
                          </td>
                        );
                      })}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Material</td>
                      {records.map((r, i) => {


                        // ✅ Display short code instead of full name
                        const displayText = r.material_short_code || r.materialNameOnly;

                        return (
                          <td key={i} className="px-3 py-1.5 border-l text-left">
                            {displayText?.toUpperCase() || "—"}
                          </td>
                        );
                      })}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Duty Ex-bond (₹)</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.dutyExbond || "—")}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Dollar (₹) (ER)</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.dollar || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Rate</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.rate || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Weight (kg)</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.apifetchweight || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Invoice Value ($)</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{r.invoiceValue || "—"}</td>
                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Duty Paid</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">
                          {r.dutypaid === true ? "Yes" : r.dutypaid === false ? "No" : "—"}
                        </td>

                      ))}
                    </tr>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Customer</td>
                      {records.map((r, i) => (
                        <td key={i} className="px-3 py-1.5 border-l text-left">{getLabelFromOptions(customerOptions, r.customer)}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>

                {/* Totals Section */}
                {/* Totals Section (From API Master Data) */}
                <div className="flex justify-end mt-4 gap-3 flex-wrap">
                  <div className="border border-gray-200 text-gray-700 px-3 py-2 rounded text-sm font-semibold min-w-[160px] text-center shadow-sm">
                    Total Duty Ex-bond: ₹{totalDuty.toFixed(2)}
                  </div>
                  <div className="border border-gray-200 text-gray-700 px-3 py-2 rounded text-sm font-semibold min-w-[160px] text-center shadow-sm">
                    Total Weight: {totalWeight.toFixed(2)} kg
                  </div>
                </div>

              </div>
            ) : (
              <NoFound />
            )}
          </div>
        </div>
      </div>
      {/* Modals */}
      {/* Delete preview modal for parent or child */}
      {showDeletePreview && pendingDeleteData && (
        <DeletePreviewModal
          title={deleteMode === "parent" ? "Exbond Details" : "Child Entry Details"}
          data={
            deleteMode === "parent"
              ? {
                "Exbond No.": pendingDeleteData.parent?.exbondNumber,
                "Total Exbond Weight": pendingDeleteData.parent?.total_weight,
              }
              : {
                "BI No.": pendingDeleteData.child?.biNumber,
                "BE No.": pendingDeleteData.child?.beNumber,
                "BE Date": formatDate(pendingDeleteData.child?.beDate),
                "Material": pendingDeleteData.child?.materialNameOnly,
                "Weight": pendingDeleteData.child?.apifetchweight,
                "Invoice Value": pendingDeleteData.child?.invoiceValue,
                "Dollar": pendingDeleteData.child?.dollar,
              }
          }
          onCancel={handleCancelPreview}
          onProceed={handleProceedToFinalConfirm}
        />
      )}

      {/* Final delete confirm modal */}
      {showFinalDeleteConfirm && pendingDeleteData && (
        <FinalDeleteConfirmModal
          title="Confirm Delete"
          message="Are you sure you want to permanently delete this entry?"
          onCancel={() => {
            setShowFinalDeleteConfirm(false);
            setPendingDeleteData(null);
            setDeleteMode(null);
          }}
          onConfirm={handleConfirmDelete}
        />
      )}
      {warningVisible && (
        <WarningModal
          message={warningMessage}
          onClose={() => setWarningVisible(false)}
        />
      )}
    </>
  );
}